/**
 * Main Entry Point for Billing System
 * Imports all modules and initializes the application
 */

// Import inline scripts first (includes Supabase initialization)
import './admin/inline-scripts/index.js';

// Import modal templates (Phase 3c: Modal Extraction)
import './templates/modal-loader.js';

// Import admin modules
import { loadBoatAnodes, saveBoatAnodes, hasUnsavedAnodeChanges, promptUnsavedAnodeChanges } from './admin/anode-persistence.js';
import { openAnodeCatalogModal, closeAnodeCatalogModal } from './admin/anode-modal.js';
import { updateAnodeAssignmentsList, updateLocationCounts, updateHistoricalAnodeConditions } from './admin/assignment-cards.js';
import { updateSliderDisplay } from './admin/conditions-tracking.js';
import { updateChargeSummary, smartChargeOrInvoice } from './admin/charge-summary.js';
import { selectAnodeLocation, renderConsolidatedForm } from './admin/service-functions.js';
import { updateWizardPricing, initializeBillingPricing } from './admin/wizard-pricing.js';
import { selectInlineCustomer, clearCustomerSelection } from './admin/inline-customer-suggest.js';
import { invoiceCustomer } from './admin/invoice-flow.js';
import { showCustomerInfoCards, hideCustomerInfoCards } from './admin/customer-info-card.js';
import { initDatePicker } from './admin/time-tracking.js';

// Import styles
import './styles/main.css';
import './styles/billing-inline.css'; // Extracted from dist/index.html inline styles
import './styles/customer-cards.css'; // Customer info card styles
import './styles/anode-modal.css'; // Anode catalog modal styles
import './styles/inventory-modal.css'; // Inventory review modal styles

// Import React bridge for condition buttons
import '../src-react/index.tsx';

// Initialize global state
if (!window.anodeAssignments) {
    window.anodeAssignments = {};
}

// Expose necessary functions to window for backwards compatibility
// (These are needed by existing inline code that will be gradually refactored)
window.loadBoatAnodes = loadBoatAnodes;
window.saveBoatAnodes = saveBoatAnodes;
window.hasUnsavedAnodeChanges = hasUnsavedAnodeChanges;
window.promptUnsavedAnodeChanges = promptUnsavedAnodeChanges;
window.openAnodeCatalogModal = openAnodeCatalogModal;
window.closeAnodeCatalogModal = closeAnodeCatalogModal;
window.updateAnodeAssignmentsList = updateAnodeAssignmentsList;
window.updateLocationCounts = updateLocationCounts;
window.updateHistoricalAnodeConditions = updateHistoricalAnodeConditions;
window.updateSliderDisplay = updateSliderDisplay;
window.updateChargeSummary = updateChargeSummary;
window.selectAnodeLocation = selectAnodeLocation;
window.renderConsolidatedForm = renderConsolidatedForm;
window.invoiceCustomer = invoiceCustomer;
window.smartChargeOrInvoice = smartChargeOrInvoice;

// Initialize application when DOM is ready
document.addEventListener('DOMContentLoaded', async () => {
    console.log('💡 Billing system initialized (modular version)');

    // Initialize dynamic pricing from Settings service (with fallback)
    await initializeBillingPricing();

    // Initialize date picker
    initDatePicker();

    // Customer search is initialized by inline-scripts/universal-search.js
    // Card components are loaded and ready

    // Inline auto-suggest is initialized when service is selected
    // (see renderBoatConfigSection in service-functions.js)

    // Any additional initialization code goes here
});

console.log('✅ Main module loaded successfully');
